/**
 * Instagram and Facebook inject their own tracking script into every page their
 * in-app browser opens. It throws in Meta's code, our global onerror picks it
 * up, and Sentry files it against whatever page the user was on. Nothing here
 * is ours to fix, and it was burying real issues.
 *
 * Verified in production before filtering: 414 of these events, every single
 * one from browser.name Instagram, Facebook, or the in-app WKWebView, none from
 * a real Safari or Chrome.
 *
 * Lives in `utils-web` rather than in one app because Meta opens links to both
 * web apps, and the shared Sentry config exists to keep their filtering
 * consistent. Every app now picks this up through that config; nothing spreads
 * it into an init of its own.
 */
export const META_IN_APP_BROWSER_ERRORS: (string | RegExp)[] = [
  // Meta's iOS bridge, absent because the page is not inside their app shell.
  "window.webkit.messageHandlers",
  // Meta's Android bridge after the native side is torn down. Matched by
  // shape, not by method name, so a new bridge method does not reopen this.
  /Error invoking \w+: Java /,
];
